import React from 'react'
import { createRoot } from 'react-dom/client';
import { initI18N } from '../../i18next';

import App from './App'

const container = document.getElementById('purchase-app-full');
const pageSource = container.dataset.source;

initI18N().then(() => {
    const root = createRoot(container);
    root.render(<App source={pageSource} />);
});
